import { useGtm } from '@gtm-support/vue-gtm'

class MietwagenModule {
  sendIframePageViewEvent (
    pageLocation: string,
    pagePath: string
  ): void {
    const gtm = useGtm()
    if (!gtm?.enabled()) {
      return
    }

    gtm.trackEvent({
      event: 'gtm.iframePageView',
      page_location: pageLocation,
      page_path: pagePath
    })
  }

  sendConversionEvent (
    total: number,
    currency: string,
    transactionId: string
  ): void {
    const gtm = useGtm()
    if (!gtm?.enabled()) {
      return
    }

    gtm.trackEvent({
      event: 'conversion',
      total,
      currency,
      transaction_id: transactionId
    })
  }
}

export default MietwagenModule
